import { Box, Button } from 'grommet';

const steps = ['Start', 'Shoot', 'Media', 'Assets', 'Roles', 'Review'];
interface IProjectWizardFooterProps {
  activeSlide: number;
  onBack: () => void;
  onNext: () => void;
  onSkip: () => void;
  onCreate: () => void;
  creating: boolean;
}

export const ProjectWizardFooter = ({ activeSlide, onBack, onNext, onSkip, onCreate, creating }: IProjectWizardFooterProps) => (
  <Box flex={false} direction="row" justify="between" align="center" background="white"
    border={{ side: 'top', color: '#E3E3E3' }} pad={{ vertical: '12px', horizontal: '16px' }}
    style={{ paddingBottom: 'max(16px, env(safe-area-inset-bottom))' }}>
    <Box>{activeSlide > 0 && <Button plain label="Back" onClick={onBack} disabled={creating}
      style={{ color: '#0d48a1', minHeight: 44 }} />}</Box>
    <Box direction="row" align="center" gap="small">
      {activeSlide > 0 && activeSlide < 5 && <Button plain label="Skip for now" onClick={onSkip}
        style={{ color: '#0d48a1', minHeight: 44 }} />}
      <Button primary label={creating ? 'Creating…' : activeSlide === 5 ? 'Create project' : `Next: ${steps[activeSlide + 1]}`}
        onClick={activeSlide === 5 ? onCreate : onNext} disabled={creating}
        style={{ background: '#0d48a1', borderRadius: 18, minHeight: 44 }} />
    </Box>
  </Box>
);
